/**
 * @generated SignedSource<<796de95e3150e72ab27c741f11b1c768>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MoveItem_container$data = {
  readonly id?: string;
  readonly scopeId?: string | null | undefined;
  readonly " $fragmentType": "MoveItem_container";
};
export type MoveItem_container$key = {
  readonly " $data"?: MoveItem_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoveItem_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "MoveItem_container",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "scopeId"
        }
      ],
      "type": "JiraContainerNavigation"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "f9f8b1902c6acb52496479dc02bba4da";

export default node;
